import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Products from "@/pages/Products";
import Orders from "@/pages/Orders";
import Club from "@/pages/Club";
import Accounting from "@/pages/Accounting";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Shell><Dashboard /></Shell>} />
            <Route path="/clients" element={<Shell><Clients /></Shell>} />
            <Route path="/produits" element={<Shell><Products /></Shell>} />
            <Route path="/commandes" element={<Shell><Orders /></Shell>} />
            <Route path="/club" element={<Shell><Club /></Shell>} />
            <Route path="/comptabilite" element={<Shell><Accounting /></Shell>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
